import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import GlucoseConcentrationTrend from '../GlucoseConcentrationTrend';
import ScrollSelector from './ScrollSelector';
const ContinuousConcentrationTrend = ({ readings, start, end, isInProgress, isReadOnly, updatePhiSet })=>{
    const [visibleStart, setVisibleStart] = useState();
    const [visibleEnd, setVisibleEnd] = useState();
    const [visibleReadings, setVisibleReadings] = useState([]);
    const ticks = useMemo(()=>{
        const ts = [
            visibleStart,
            visibleStart + 6 * 3600,
            visibleStart + 12 * 3600,
            visibleStart + 18 * 3600,
            visibleStart + 24 * 3600
        ];
        return ts;
    }, [
        visibleStart
    ]);
    useEffect(()=>{
        const vStart = +moment.unix(end).utc().locale('en').startOf('day').format('X');
        setVisibleStart(vStart);
        setVisibleEnd(end);
    }, [
        start,
        end
    ]);
    useEffect(()=>{
        const vReadings = readings.filter((reading)=>reading.timestamp >= visibleStart && reading.timestamp <= visibleEnd);
        setVisibleReadings(vReadings);
    }, [
        readings,
        visibleStart
    ]);
    const setVisibleDay = (newStart, newEnd)=>{
        setVisibleStart(newStart);
        setVisibleEnd(newEnd);
    };
    const formatLabel = (timestamp)=>moment.unix(timestamp).utc().format('LT');
    const renderTick = (tickProps)=>{
        const { value, x, y, textX, textY, rotate, textAnchor, textBaseline, format } = tickProps;
        const formattedValue = format(value);
        return /*#__PURE__*/ _jsx("g", {
            transform: `translate(${x},${y})`,
            style: {
                opacity: 1
            },
            children: /*#__PURE__*/ _jsx("text", {
                dominantBaseline: textBaseline,
                textAnchor: textAnchor,
                transform: `translate(${textX},${textY}) rotate(${rotate})`,
                style: {
                    fontFamily: 'sans-serif',
                    fontSize: '11px',
                    fill: 'rgb(51, 51, 51)'
                },
                children: formattedValue
            })
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(GlucoseConcentrationTrend, {
                ticks: ticks,
                isInProgress: isInProgress,
                isReadOnly: isReadOnly,
                formatLabel: formatLabel,
                updatePhiSet: updatePhiSet,
                readings: visibleReadings,
                start: visibleStart,
                end: visibleEnd,
                dataType: "CGM",
                isCustomRanges: false,
                isLineEnabled: true,
                showRelatedData: false,
                renderTick: renderTick
            }),
            /*#__PURE__*/ _jsx(ScrollSelector, {
                start: start,
                end: end,
                visibleStart: visibleStart,
                setVisibleDay: setVisibleDay
            })
        ]
    });
};
export default ContinuousConcentrationTrend;
